import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/da/alarmanalysis/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const searchByName = (params, urlParams) => {
  return axios.request({
    url: '/da/alarmanalysis/searchbyname/' + params.name + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/da/alarmanalysis/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/da/alarmanalysis/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const modifyObj = (params, urlParams) => {
  return axios.request({
    url: '/da/alarmanalysis/modify' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/da/alarmanalysis/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const batchModifyObj = (params, urlParams) => {
  return axios.request({
    url: '/da/alarmanalysis/batchmodify/' + params.ids + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

